import { get } from 'lodash';


function getShortLocale(language) {
  if (!language) {
    // default locale
    return 'ko';
  }
  if (/^ko(-([\w]{1,4}))?$/.test(language)) {
    return 'ko';
  }
  if (/^en(-([\w]{1,4}))?$/.test(language)) {
    return 'en';
  }
  if (/^ja(-([\w]{1,4}))?$/.test(language)) {
    return 'ja';
  }
  if (/^es(-([\w]{1,4}))?$/.test(language)) {
    return 'es';
  }
  if (/^tr(-([\w]{1,4}))?$/.test(language)) {
    return 'tr';
  }
  if (/^vi(-([\w]{1,4}))?$/.test(language)) {
    return 'vi-VN';
  }
  if (/^ms(-([\w]{1,4}))?$/.test(language)) {
    return 'ms-MY';
  }
  if (/^id(-([\w]{1,4}))?$/.test(language)) {
    return 'id-ID';
  }
  if (/^th(-([\w]{1,4}))?$/.test(language)) {
    return 'th-TH';
  }
  if (/^ru(-([\w]{1,4}))?$/.test(language)) {
    return 'ru-RU';
  }
  if (language === 'zh-tw') {
    return 'zh-TW';
  }

  return language;
}


export default {
  methods: {
    getLocale(userInfo) {
      let language = get(this, '$route.query.lang');

      if (!language) {
        language = get(userInfo, 'language');
      }

      return getShortLocale(language);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/locales.js